<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block"></div>

            <Header></Header>

            <section class="content create-due-content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-11 form-request-content-large">
                            <div class="request-title">
                                <h1>DUE : Créer</h1>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-10 form-request-content-large">
                          <ul class="breadcrumb-steps">
                            <li class="breadcrumb-steps__item success mobile-hide">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Création du modèle de DUE
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide success">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Paramétrage des bénéficiaires
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide success">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Paramétrage des cotisations
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item success">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Délais applicables
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item active">
                              <span class="breadcrumb-steps__num">5</span>
                              <span class="breadcrumb-steps__descr">
                                Cas de dispense facultatifs
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item">
                              <span class="breadcrumb-steps__num">6</span>
                              <span class="breadcrumb-steps__descr">
                                Documents annexes
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">7</span>
                              <span class="breadcrumb-steps__descr">
                                Informations importantes
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">8</span>
                              <span class="breadcrumb-steps__descr">
                                Signature éléctronique
                              </span>
                            </li>
                          </ul>
                        </div>
                    </div>

                    <div class="row"></div>
                    <div class="col-md-10 form-request-content-large">
                        <div class="required-field-text">Champs obligatoires</div>
                        <div class="form-group">
                            <form
                                    name="exemption"
                                    method="post"
                                    enctype="multipart/form-data"
                                    novalidate="novalidate"
                                    class="needs-validation"
                            >
                                <div class="motif-due-border" v-if="dueReasons.length > 0">
                                    <h2>Cas de dispense facultatifs </h2>
                                    <p class="input-legend due-motifs-help-text">Cas de dispense facultatifs
                                        que vous pouvez proposer à vos salariés, conformément à la loi et aux
                                        règles contenues dans la convention collective applicable.<br>
                                        Cochez les cases pour les cas que vous choisissez de proposer à vos salariés.</p>
                                    <div class="check-container">
                                        <!-- checkbox -->
                                        <div v-for="(dueReason, index) in dueReasons"
                                             :key="index"
                                             class="form-group clearfix border-due-checkbox-input">
                                            <div class="icheck-primary d-inline">
                                                <input type="checkbox"
                                                       :id="dueReason.reason.id"
                                                       :disabled="dueReason.required || isValidCDF1Condition(dueReason.reason.code)"
                                                       :checked="dueReason.required"
                                                       :value="dueReason.reason.id"
                                                       v-model="formData.optionalReasons"
                                                >
                                                <label :for="dueReason.reason.id">
                                                    <span>{{ dueReason.reason.titleHro }}</span>
                                                </label>
                                                <p v-if="dueReason.reason.code === 'cdf1' && legalInformation"
                                                   class="input-legend--motif"
                                                >{{ legalInformation.cdf1Reason.legalAdvice }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Contributions -->
                            </form>
                        </div>
                    </div>

                    <div class="input-group col-md-10 mx-sm-auto my-md-4">
                        <div class="mx-sm-auto">
                            <button class="btn btn-lg btn-link btn__primary"
                                    :disabled="saveIsLoading || nextStepIsLoading"
                                    @click.prevent="toPreviousStep('due-fourth-step')"
                            >
                                <span>Revenir à l'étape précédente</span>
                            </button>

                            <button class="btn btn-success btn-lg ml-4 btn-link btn__save"
                                    :disabled="saveIsLoading || nextStepIsLoading"
                                    @click.prevent="saveDue()"
                            >
                                <span>Enregistrer le brouillon</span>
                                <ButtonSpinner :isLoading="saveIsLoading"></ButtonSpinner>
                            </button>
                        </div>
                    </div>

                    <div class="input-group mx-sm-auto">
                        <div class="large-btn__box">
                            <button class="btn btn-success btn-lg btn-link btn__save--large"
                                    :disabled="saveIsLoading || nextStepIsLoading"
                                    @click.prevent="saveAndMoveForward('due-sixth-step')"
                            >
                                <span>Enregistrer les modifications</span>
                                <ButtonSpinner :isLoading="nextStepIsLoading"></ButtonSpinner>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../../../components/Sidebar';
    import Footer from '../../../components/Footer';
    import ButtonSpinner from '../../../components/ButtonSpinner';
    import DueFifthStepManager from '../../../service/manager/due/fifthStepManager';
    import DueStepsNavigation from '../../../mixins/dueStepsNavigation';
    import Header from '../../../components/Header';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        mixins: [DueStepsNavigation],
        data() {
            return {
                formData: {
                    optionalReasons: []
                },
                saveIsLoading: false,
                nextStepIsLoading: false
            };
        },
        computed: {
            ...mapGetters({
                due: 'due',
                dueReasons: 'dueReasons',
                legalInformation: 'legalInformation'
            }),
            isCDF1available() {
                if (Object.entries(this.due).length === 0) {
                    return false;
                }

                return this.due.contributions.filter((contribution) => {
                    return contribution.employerSharePercentage === 100;
                }).length > 0;
            }
        },
        async created() {
            await this.fetchDue();
            await this.fetchDueLegalInformation();
            await this.fetchDueReasons();
            this.processDueReasons();
            await this.setCurrentStep(5);
        },
        methods: {
            ...mapActions({
                setCurrentStep: 'setCurrentStep',
                fetchCurrentDue: 'fetchCurrentDue',
                updateCurrentDue: 'updateCurrentDue',
                fetchDueReasons: 'fetchDueReasons',
                fetchDueLegalInformation: 'fetchDueLegalInformation'
            }),
            async fetchDue() {
                await this.fetchCurrentDue(this.$route.params.id);
                this.formData = {
                    ...this.formData,
                    ... await DueFifthStepManager.createFormDataFromResponse(this.due)
                }
            },
            async prepareRequest() {
                return this.formData;
            },
            processDueReasons() {
                for (const reason of this.dueReasons) {
                    if (reason.required) {
                        this.formData.optionalReasons.push(reason.reason.id);
                    }
                }
            },
            isValidCDF1Condition(reasonCode) {
                // todo:: if will add new specific collectiveAgreement, need to refactor this
                if (this.due.collectiveAgreement.id === 54 && reasonCode === 'cdf1') {
                    return false;
                }

                return (!this.isCDF1available && reasonCode === 'cdf1');
            }
        },
        components: {
            Header,
            Footer,
            Sidebar,
            ButtonSpinner
        }
    }
</script>
